import { PURGE } from "redux-persist";

const initialState = {
  submissionStats: {},
  resourcesStats: [],
};

export default (state = initialState, { type, payload }: any) => {
  switch (type) {
    case "FETCH_SUBMISSION_STATS":
      return {
        ...state,
        submissionStats: payload,
      };
    case "FETCH_REPORTS":
      return {
        ...state,
        reports: payload,
      };
    case "CLEAR_ORGANIZATION_DATA":
      return initialState;
    case PURGE:
      return initialState;
    case "FETCH_RESOURCES_STATS":
      return {
        ...state,
        resourcesStats: payload,
      };
    default:
      return state;
  }
};
